export default {
  activeTabModel(state) {
    return state.activeTabModel
  },
  active(state) {
    return state.list[state.activeTabModel]
  },
  infoTab(state) {
    return state.list[state.activeTabModel].infoTab
  },
  gameHistory(state) {
    return state.list[state.activeTabModel].gameHistory
  },
  sportHistory(state) {
    return state.list[state.activeTabModel].sportHistory
  },
  totalOpenBets(state) {
    return state.list[state.activeTabModel].totalOpenBets
  },
  finance(state) {
    return state.list[state.activeTabModel].finance
  },
  bonus(state) {
    return state.list[state.activeTabModel].bonus
  },
  packages(state) {
    return state.list[state.activeTabModel].packages
  },
  shop(state) {
    return state.list[state.activeTabModel].shop
  },
  benefits(state) {
    return state.list[state.activeTabModel].benefits
  },
  stats(state) {
    return state.list[state.activeTabModel].stats
  },
  comments(state) {
    return state.list[state.activeTabModel].comments
  },
  documents(state) {
    return state.list[state.activeTabModel].kyc.documents
  },
  kyc(state) {
    return state.list[state.activeTabModel].kyc.info
  },
  oauth(state) {
    return state.list[state.activeTabModel].oauth.data
  },
  kycData(state) {
    return state.list[state.activeTabModel].kyc.data
  },
  recentTransactions(state) {
    return state.list[state.activeTabModel].recentTransactions
  },
  duplicates(state) {
    return state.list[state.activeTabModel].duplicates
  },
  loginHistory(state) {
    return state.list[state.activeTabModel].loginHistory
  },
  limits(state) {
    return state.list[state.activeTabModel].limits
  },
  tasks(state) {
    return state.list[state.activeTabModel].tasks
  },
  list(state) {
    return state.list
  }
}
